import { useQuery } from '@apollo/client'
import { graphql, useStaticQuery } from 'gatsby'
import isEmpty from 'lodash.isempty'
import { useEffect, useState } from 'react'
import GET_PERSONAS from '../apollo/queries/GET_PERSONAS'
import { getDeliverablesByCategory } from '../utils/strategyBuilder'

const GET_PERSONA_AND_ADDITIONAL_SERVICES = graphql`
  {
    allContentfulStrategyBuilderDeliverableCardV2 {
      edges {
        node {
          id
          title
          category
          description {
            description
          }
          descriptionMarketingStrategies {
            descriptionMarketingStrategies
          }
          investableAssets
          image {
            file {
              url
            }
          }
          url {
            file {
              url
            }
          }
        }
      }
    }
    allContentfulStrategyBuilderSummary(
      filter: {
        title: { eq: "Strategy Builder Target Market Summary Buttons" }
      }
    ) {
      nodes {
        additionalServices {
          id
          text
          title
          url
        }
      }
    }
  }
`

export function useDeliverables(category = 'Target Market') {
  const [deliverablesByCategory, setDeliverablesByCategory] = useState([])
  const [deliverables, setDeliverables] = useState([])
  const { data: personaPlans } = useQuery(GET_PERSONAS)

  const {
    allContentfulStrategyBuilderDeliverableCardV2: contentfulData,
    allContentfulStrategyBuilderSummary: additionalServicesData,
  } = useStaticQuery(GET_PERSONA_AND_ADDITIONAL_SERVICES)

  useEffect(() => {
    if (!isEmpty(contentfulData))
      setDeliverablesByCategory(
        getDeliverablesByCategory({
          contentfulData,
          personaPlans,
        })
      )
  }, [contentfulData])

  useEffect(() => {
    if (isEmpty(deliverablesByCategory)) return
    const personas = deliverablesByCategory.find(
      group => group.category === category
    )
    if (isEmpty(personas)) return
    setDeliverables(personas.deliverables)
  }, [deliverablesByCategory])

  return {
    deliverables,
    deliverablesByCategory,
    additionalServices: additionalServicesData?.nodes[0]?.additionalServices,
  }
}
